import React, { useEffect, useState } from "react";

const UserAppointmentsPopup = ({ firebase, onClose }) => {
  const userEmail = firebase.auth.currentUser.email;
  const today = new Date();

  const [weekOffset, setWeekOffset] = useState(0);
  const [requestedSlots, setRequestedSlots] = useState({});
  const [confirmedSlots, setConfirmedSlots] = useState({});
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  /* ✅ FETCH USER’S APPOINTMENTS */
//   useEffect(() => {
//     const today = new Date().toISOString().split("T")[0];
//     debugger;
//     const unsub = firebase.db
//       .collection("appointmentSchedules")
//       .where("userEmail", "==", userEmail)
//       .where("status", "in", ["requested", "confirmed"])
//       .where("appointmentDate", ">=", today)
//       .onSnapshot((snap) => {
//         const req = {};
//         const conf = {};

//         snap.docs.forEach((doc) => {
//           const d = doc.data();
// debugger;
//           // only future or today’s appointments
//           const apptDate = new Date(`${d.appointmentDate}T00:00:00`);
//           if (apptDate < today) return;

//           if (d.status === "requested") {
//             if (!req[d.appointmentDate]) req[d.appointmentDate] = {};
//             req[d.appointmentDate][d.time] = { id: doc.id, ...d };
//           }

//           if (d.status === "confirmed") {
//             if (!conf[d.appointmentDate]) conf[d.appointmentDate] = {};
//             conf[d.appointmentDate][d.time] = { id: doc.id, ...d };
//           }
//         });

//         setRequestedSlots(req);
//         setConfirmedSlots(conf);
//       },
//     (error) => {
//       console.error("Firestore onSnapshot error:", error);
//       // optional: show toast / set error state
//       // setError(error.message);
//     });

//     return () => unsub();
//   }, [firebase, userEmail]);

// useEffect(() => {
//   if (!userEmail) return;

//   const todayStr = new Date().toISOString().split("T")[0];
//   const todayDate = new Date(`${todayStr}T00:00:00`);

//   const unsub = firebase.db
//     .collection("appointmentSchedules")
//     .where("userEmail", "==", userEmail)
//     .onSnapshot(
//       (snap) => {
//         const req = {};
//         const conf = {};

//         snap.docs.forEach((doc) => {
//           const d = doc.data();

//           // Filter status manually
//           if (!["requested", "confirmed"].includes(d.status)) return;

//           // Filter date manually
//           const apptDate = new Date(`${d.appointmentDate}T00:00:00`);
//           if (apptDate < todayDate) return;

//           if (d.status === "requested") {
//             if (!req[d.appointmentDate]) req[d.appointmentDate] = {};
//             req[d.appointmentDate][d.time] = { id: doc.id, ...d };
//           }

//           if (d.status === "confirmed") {
//             if (!conf[d.appointmentDate]) conf[d.appointmentDate] = {};
//             conf[d.appointmentDate][d.time] = { id: doc.id, ...d };
//           }
//         });

//         setRequestedSlots(req);
//         setConfirmedSlots(conf);
//       },
//       (error) => {
//         console.error("Firestore error:", error);
//       }
//     );

//   return () => unsub();
// }, [firebase, userEmail]);  


useEffect(() => {
  if (!userEmail) return;

  const todayStr = new Date().toISOString().split("T")[0];
  const todayDate = new Date(`${todayStr}T00:00:00`);

  const normalizeTime = (timeStr) => {
    if (!timeStr) return "";

    const [t, mod] = timeStr.trim().split(" ");
    let [h, m] = t.split(":");
    h = parseInt(h);

    // Remove leading zero
    if (h < 10) h = parseInt(h);

    return `${h}:${m} ${mod}`;
  };

  const unsub = firebase.db
    .collection("appointmentSchedules")
    .where("userEmail", "==", userEmail)
    .onSnapshot((snap) => {

      const req = {};
      const conf = {};

      snap.forEach((doc) => {
        const d = doc.data();

        if (!["requested", "confirmed"].includes(d.status)) return;

        /* 🔥 Normalize Date */
        let dateKey = "";

        if (d.appointmentDate?.toDate) {
          dateKey = d.appointmentDate
            .toDate()
            .toISOString()
            .split("T")[0];
        } else {
          dateKey = d.appointmentDate;
        }

        const apptDate = new Date(`${dateKey}T00:00:00`);
        if (apptDate < todayDate) return;

        /* 🔥 Normalize Time */
        const timeKey = normalizeTime(d.time);

        if (!dateKey || !timeKey) return;

        if (d.status === "requested") {
          if (!req[dateKey]) req[dateKey] = {};
          req[dateKey][timeKey] = { id: doc.id, ...d };
        }

        if (d.status === "confirmed") {
          if (!conf[dateKey]) conf[dateKey] = {};
          conf[dateKey][timeKey] = { id: doc.id, ...d };
        }
      });

      setRequestedSlots(req);
      setConfirmedSlots(conf);
    });

  return () => unsub();
}, [firebase, userEmail]);


  const getWeekDates = () => {
    const dates = [];
    const start = new Date();
    start.setDate(today.getDate() + weekOffset * 7);

    for (let i = 0; i < 7; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      dates.push(d);
    }
    return dates;
  };

  const weekDates = getWeekDates();

  const timeSlots = [
    "08:00 AM","09:00 AM","10:00 AM","11:00 AM",
    "12:00 PM","01:00 PM","02:00 PM","03:00 PM",
    "04:00 PM","05:00 PM","06:00 PM","07:00 PM","08:00 PM"
  ];

  const formatDateKey = (date) =>
    date.toISOString().split("T")[0];

  const isPastSlot = (date, time) => {
    const [t, mod] = time.split(" ");
    let [h] = t.split(":");
    h = parseInt(h);
    if (mod === "PM" && h !== 12) h += 12;
    if (mod === "AM" && h === 12) h = 0;

    const slotTime = new Date(date);
    slotTime.setHours(h, 0, 0, 0);
    return slotTime < new Date();
  };

  return (
    <>
      {/* POPUP WRAPPER */}
      <div style={styles.overlay}>
        <div style={styles.popupBox}>
          <div style={styles.card}>

            {/* HEADER */}
            <div style={styles.header}>
              <div>
                <div style={{ fontSize: "12px", opacity: 0.7 }}>
                  YOUR APPOINTMENTS
                </div>
                <div style={{ fontSize: "15px" }}>
                  {weekDates[0].toDateString()} – {weekDates[6].toDateString()}
                </div>
              </div>

              <div style={{ display: "flex", gap: "10px" }}>
                <button style={topBtn} onClick={() => setWeekOffset(0)}>
                  ← Current Week
                </button>
                <button
                  style={topBtn}
                  onClick={() => setWeekOffset(weekOffset + 1)}
                >
                  Next Week →
                </button>
                <button onClick={onClose} style={closeBtn}>✕</button>
              </div>
            </div>

            {/* GRID */}
            <div style={grid}>
              <div></div>

              {weekDates.map((d) => (
                <div key={d} style={dayHeader}>
                  {d.toDateString().slice(0, 10)}
                </div>
              ))}

              {timeSlots.map((time) => (
                <React.Fragment key={time}>
                  <div style={timeCell}>{time}</div>

                  {weekDates.map((date) => {
                    const dateKey = formatDateKey(date);

                    const req = requestedSlots?.[dateKey]?.[time];
                    const conf = confirmedSlots?.[dateKey]?.[time];
                    const isPast = isPastSlot(date, time);
                    return (
                      <div
                        key={dateKey + time}
                        style={{
                          ...slotCell,
                          cursor: req || conf ? "pointer" : "default",
                          opacity: isPast ? 0.35 : 1
                        }}
                        onClick={() =>
                          (req || conf) && setSelectedAppointment(req || conf)
                        }
                      >
                        {/* REQUESTED */}
                        {req && (
                          <div style={{
                            ...pill,
                            background:
                              "linear-gradient(135deg,#f59e0b,#d97706)"
                          }}>
                            Requested
                          </div>
                        )}

                        {/* CONFIRMED */}
                        {conf && (
                          <div style={{
                            ...pill,
                            background:
                              "linear-gradient(135deg,#2563eb,#1d4ed8)"
                          }}>
                            Confirmed
                          </div>
                        )}
                      </div>
                    );
                  })}
                </React.Fragment>
              ))}
            </div>

          </div>
        </div>
      </div>

      {/* SELECTED APPOINTMENT POPUP */}
      {selectedAppointment && (
        <div style={styles.confirmOverlay}>
          <div style={styles.confirmPopupDark}>
            <h3>Appointment Details</h3>

            <p><b>Doctor:</b> {selectedAppointment.doctorEmail}</p>
            <p><b>Date:</b> {selectedAppointment.appointmentDate}</p>
            <p><b>Time:</b> {selectedAppointment.time}</p>
            <p><b>Status:</b> {selectedAppointment.status}</p>

            {/* Zoom link for confirmed */}
            {selectedAppointment.status === "confirmed" && (
              <p>
                <b>Zoom: </b>
                <a
                  href={selectedAppointment.joinUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#60a5fa" }}
                >
                  Join Meeting
                </a>
              </p>
            )}

            <button
              style={styles.closeSecondaryBtn}
              onClick={() => setSelectedAppointment(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UserAppointmentsPopup;

/* === STYLES (same theme as doctor calendar) === */

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999
  },
  popupBox: {
    width: "95%",
    maxHeight: "90vh",
    overflowY: "auto",
    background: "rgba(0,0,0,0.6)",
    borderRadius: "12px"
  },
  card: {
    background: "#070d1b",
    borderRadius: "18px",
    padding: "24px",
    color: "#fff",
    margin: "20px"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px"
  },
  confirmOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.75)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 100000
  },
  confirmPopupDark: {
    background: "#0b0f1a",
    padding: "20px",
    borderRadius: "12px",
    width: "320px",
    color: "#fff",
    boxShadow: "0 0 25px rgba(0,0,0,0.8)"
  },
  closeSecondaryBtn: {
    background: "#374151",
    color: "#fff",
    padding: "8px 16px",
    marginTop: "15px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    width: "100%"
  }
};

const topBtn = {
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(255,255,255,0.25)",
  color: "#fff",
  padding: "8px 12px",
  borderRadius: "10px",
  cursor: "pointer"
};

const closeBtn = {
  background: "#dc2626",
  border: "none",
  color: "#fff",
  padding: "8px 12px",
  borderRadius: "50%",
  cursor: "pointer"
};

const grid = {
  display: "grid",
  gridTemplateColumns: "90px repeat(7, 1fr)",
  gap: "10px"
};

const dayHeader = { textAlign: "center", opacity: 0.8 };
const timeCell = { opacity: 0.7 };
const slotCell = {
  height: "46px",
  borderRadius: "10px",
  background: "rgba(255,255,255,0.05)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};
const pill = {
  padding: "6px 12px",
  borderRadius: "999px",
  fontSize: "11px",
  color: "#fff"
};
